//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FixedList',
  components: {
    log: function log() {
      return import('./components/log');
    }
  }
};